export function replaceAutoGenerateTinyMceText(text: string): string {
  const tinyMceGeneratedText = `<br data-mce-bogus="1">`;
  return text.replace(tinyMceGeneratedText, '');
}
